import { GridCellParams } from '@mui/x-data-grid-pro';
import User from 'types/entities/User';

export function isWorkunitResetable(params: GridCellParams<any, any, any>) {
  return params.row.mission_advancement_id && params.row.mission_advancement_id >= 1;
}

export function getFullName(value: any, row: any, property: 'consultant' | 'client') {
  const user: User | null = row?.[property];
  if (user) return `${row?.[property]?.last_name || ''} ${row?.[property]?.first_name || ''}`;
  return '';
}

export function setFullName(value: any, row: any, property: 'consultant' | 'client') {
  const user: User | null = row?.[property];

  if (user) {
    const full_name = `${user?.last_name || ''} ${user?.last_name || ''}`;
    if (full_name) return { ...row, [`${property}_fullname`]: full_name };
  }
  return { ...row, [`${property}_fullname`]: '' };
}
